import { initDycolor } from '~';

initDycolor('stat-box', require(`${process.env.DYCOLOR_REQUIRE}./StatBox.scss`)); // eslint-disable-line

export default {
  props: {
    icon: {
      type: String,
      default: 'no-icon',
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      default: 0,
    },
    details: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },
  },
  computed: {
    classNames() {
      return `stat-box--icon-${this.icon}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-statistics/stat-box/StatBox.js